import { useState, forwardRef, ForwardedRef, useImperativeHandle } from 'react';
import styled from './index.module.scss';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import { GiftIcon3 } from '@/components/UI/svg/Referral';
import { useGlobal } from '@/utils/useGlobal';
import { getCurrentPlan } from '@/service/referral';
import getLocal from '@/app/utils/getLocal';

interface OldUserModalProps {
    width?: number;
}

export type OldUserModalHandle = {
    show: () => void;
};

const OldUserModal = ({ width = 560 }: OldUserModalProps, ref: ForwardedRef<OldUserModalHandle>) => {
    const { Link, useLang } = useGlobal();
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const [show, setShow] = useState(false);
    const [hasActivity, setHasActivity] = useState(false);
    const path = `/${locale}${pathname}`;

    useImperativeHandle(ref, () => ({
        show: () => {
            // 如果存在分裂计划 跳转活动页面
            getCurrentPlan(locale, path).then((res) => {
                if (res.data && res.data.planId) setHasActivity(true);
            });
            setShow(true);
        },
    }));

    return (
        <EfModal
            width={width}
            visible={show}
            open={show}
            className={`${styled.olduser_modal}`}
            centered={true}
            getContainer={true}
            onCancel={() => setShow(false)}
        >
            <div className="content">
                <GiftIcon3 />
                <p className="msg">{t('olduser_msg')}</p>
                <Link href={hasActivity ? `/${locale}/referral` : `/${locale}/ecocredits`}>
                    <Button className="btn">{t('olduser_btn')}</Button>
                </Link>
            </div>
        </EfModal>
    );
};

export default forwardRef<OldUserModalHandle, OldUserModalProps>(OldUserModal);
